// UTC Timezone constant
export const DEFAULT_TIMEZONE = "Africa/Abidjan"
